// extracted by mini-css-extract-plugin
module.exports = {"dg200ImgTextB":"ImgTextB_dg200ImgTextB__SXGGw"};